import { Navigate, useLocation } from 'react-router-dom';

type TemplePrivateRouteProps = {
    component: React.ComponentType;
};

const TemplePrivateRoute = ({
    component: RouteComponent,
}: TemplePrivateRouteProps) => {
    const location = useLocation();

    const templeAccessToken = localStorage.getItem('templeAccessToken');

    if (!templeAccessToken) {
        return (
            <Navigate
                to="/account/temple-login"
                state={{ from: location }}
                replace
            />
        );
    }

    return <RouteComponent />;
};

export default TemplePrivateRoute;